export default "__VITE_ASSET__BVjedy4G__"